import { render } from "./ProfileMapping.vue?vue&type=template&id=b6fc4b30&scoped=true&lang=pug"
import script from "./ProfileMapping.vue?vue&type=script&lang=js"
export * from "./ProfileMapping.vue?vue&type=script&lang=js"

import "./ProfileMapping.vue?vue&type=style&index=0&id=b6fc4b30&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6fc4b30"]])

export default __exports__